import React, {Component}      from "react";
import {
  Modal,
  Panel,
  Button
}                              from "react-bootstrap";
import moment                  from "moment";

import {
  EVOUCHER_UPDATE_LOGS
}                              from "actions/const";

import { IS_VALID }            from "utils";
import saveTrail               from "utils/saveTrail";

import CrudComponent           from "./../zynappse-crud";
import VoucherUpdateLogsSchema from "./VoucherUpdateLogs.js";
import FormContainer           from "./FormContainer";

class EVoucherUpdateLogsComponent extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;

    this.refreshTable = this.refreshTable.bind(this);
    this.getParseConfig = this.getParseConfig.bind(this);
    this.updateParseConfig = this.updateParseConfig.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  refreshTable () {
    if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
      this.refreshTableReference();
    }
  }

  readVoucherUpdateLog (filename) {
    return new Promise((resolve, reject) => {
      Parse.Cloud.run(
        "readVoucherUpdateLog",
        {
          filename
        }
      )
      .then(resolve)
      .catch((err) => {
        console.log("readVoucherUpdateLog error: ", err);
        reject(err);
      })
    });
  }

  getParseConfig () {
    let {
      actions
    } = this.props;

    actions.setValue(
      EVOUCHER_UPDATE_LOGS,
      {
        isLoadingConfig: true
      }
    );

    Parse.Config.get()
    .then((config) => {
      actions.setValue(
        EVOUCHER_UPDATE_LOGS,
        {
          isLoadingConfig: false,
          isActive: config.get("ENABLE_UPDATE_POINTS_LOG") || false
        }
      );
    })
    .catch((err) => {
      console.log("getParseConfig error");
      console.log(err);

      actions.setValue(
        EVOUCHER_UPDATE_LOGS,
        {
          isLoadingConfig: false
        }
      );
    });
  }

  updateParseConfig () {
    let {
      EVoucherUpdateLogs,
      actions
    } = this.props;

    let {
      isActive
    } = EVoucherUpdateLogs;

    actions.setValue(
      EVOUCHER_UPDATE_LOGS,
      { isSavingConfig: true }
    );

    Parse.Cloud.run(
      "enableUpdatePointsLog",
      {
        isEnable: !isActive
      }
    )
    .then(() => {
      let stateToUpdate = {
        isSavingConfig: false,
        isActive: !isActive,
        showModalConfig: false
      };

      actions.setValue(
        EVOUCHER_UPDATE_LOGS,
        stateToUpdate
      );

      saveTrail(
          isActive ? "DISABLE SAVING" : "ENABLE SAVING",
          {
            isEnable: !isActive
          }
      );
    })
    .catch((err) => {
      console.log("updateParseConfig error");
      console.log(err);

      actions.setValue(
        EVOUCHER_UPDATE_LOGS,
        {
          isSaving: false,
          showModalConfig: false
        }
      );
    });
  }

  accessible (actionType) {
    let {
        access
      } = this.props.accessjson;
  
      if (access.length !== 0) {
        var currentPath = window.location.pathname,
                index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
                actions = [];

        if (access[index]) {
            actions = access[index].actions
        }

        if (actions.length != 0) {
            if (actions.indexOf(actionType.toUpperCase()) === -1) {
                return 'none';
            } else {
                return '';
            }
        } else {
            return 'none';
        }
    } else {
        return 'none';
    }
}
  
  render () {
    let {
      EVoucherUpdateLogs,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle,

      showModalConfig,
      isSavingConfig,
      isLoadingConfig,
      isActive
    } = EVoucherUpdateLogs;

    let crudProps = {
      schema: VoucherUpdateLogsSchema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      refreshTable: (refreshTable) => {
        this.refreshTableReference = refreshTable;
      },
      customView: (obj) => {
        let title = "LOGS";

        if (IS_VALID(obj.get("startTime"))) {
          title = moment(obj.get("startTime")).format("MMM DD, YYYY hh:mm:ss A") + " Logs";
        }

        actions.setValue(
          EVOUCHER_UPDATE_LOGS,
          {
            showModal: true,
            formType: "VIEW",
            formTitle: title,
            selectedData: obj
          }
        );
      },
      customItems: [
        {
          columnName: "daily_voucher_log",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = (
                <p style={{ whiteSpace: "pre" }}>
                  {value.substr(0, 20).trim() + (value.length <= 20 ? "" : "...")}
                </p>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "campaign_period_voucher_log",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = (
                <p style={{ whiteSpace: "pre" }}>
                  {value.substr(0, 20).trim() + (value.length <= 20 ? "" : "...")}
                </p>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "date_range_voucher_log",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = (
                <p style={{ whiteSpace: "pre" }}>
                  {value.substr(0, 20).trim() + (value.length <= 20 ? "" : "...")}
                </p>
              );
            }

            return renderValue;
          }
        }
      ]
    };

    let formContainerProps = {
      ...this.props,
      readVoucherUpdateLog: this.readVoucherUpdateLog
    };

    let isEnableSavingAccessible = this.accessible("ENABLE SAVING") === "",
        isDisableSavingAccessible = this.accessible("DISABLE SAVING") === "";

    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4 style={{ display: "inline-block" }}>Update Points Log</h4>
            <div style={{ float: "right" }}>
              <Button
              style={(isActive ? !isDisableSavingAccessible : !isEnableSavingAccessible) ? { cursor: "not-allowed" } : null}
              bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
              disabled={isLoadingConfig || (isActive ? !isDisableSavingAccessible : !isEnableSavingAccessible)}
              onClick={() => {
                if (
                    (isActive ? !isDisableSavingAccessible : !isEnableSavingAccessible)
                ) {
                    return;
                }

                actions.setValue(
                  EVOUCHER_UPDATE_LOGS,
                  {
                    showModalConfig: true
                  }
                );
              }}
              >
                {isLoadingConfig ? (
                  <i className="fa fa-spinner fa-spin"/>
                ) : (
                  isActive ? "SAVING ENABLED" : "SAVING DISABLED"
                )}
              </Button>
            </div>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
          bsSize={"lg"}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction) {
              actions.setValue(
                EVOUCHER_UPDATE_LOGS,
                {
                  showModal: false
                }
              );
            }
          }}
          >
          <Modal.Header closeButton>
            <Modal.Title>{formType.toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
        </Modal>
        <Modal
          show={showModalConfig}
          onHide={() => {
            if (!isSavingConfig) {
              actions.setValue(
                EVOUCHER_UPDATE_LOGS,
                {
                  showModalConfig: false
                }
              );
            }
          }}
          bsSize="small"
        >
          <Modal.Header closeButton>
            <h4>{isActive ? "DISABLE" : "ENABLE"} SAVING</h4>
          </Modal.Header>
          <Modal.Body>
            {`Are you sure you want to ${isActive ? "disable" : "enable"} saving of logs?`}
          </Modal.Body>
          <Modal.Footer>
              <Button
                bsStyle={isActive ? "danger" : "success"}
                disabled={isSavingConfig}
                onClick={() => this.updateParseConfig()}
              >
                {isActive ? "DISABLE" : "ENABLE"} SAVING
              </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  componentDidMount () {
    this.getParseConfig();
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	var {
    EVoucherUpdateLogs,
    accessjson
	} = state;

	const props = {
    EVoucherUpdateLogs,
    accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EVoucherUpdateLogsComponent);



// WEBPACK FOOTER //
// ./components/EVoucherUpdateLogs/index.js